import InputSearchText from './InputSearchText'

export default InputSearchText
